// /**
//  * Color Code Replacer
//  * Replaces Colour Code pill numbers with color names from the mapping
//  * 
//  * Features:
//  * - Preloads ALL color codes from all families (doesn't require Colour Family selection)
//  * - Prevents reverting from color names back to numbers
//  * - Aggressively monitors and fixes any reverts in real-time
//  * - Option to hide Colour Family fieldset (uncomment in init function)
//  */

// (function() {
//   'use strict';

//   // Inject CSS IMMEDIATELY - before anything else loads
//   // This ensures numbers are hidden from the very start
//   const style = document.createElement('style');
//   style.textContent = `
//     /* CRITICAL: Hide ALL labels in Colour Code fieldset immediately on page load */
//     /* This runs before JavaScript, preventing numbers from ever being visible */
//     fieldset.product-form__input--pill:has(legend:contains("Colour Code")) label,
//     fieldset.product-form__input--pill:has(legend:contains("Color Code")) label,
//     fieldset.product-form__input--pill.color-code-fieldset label {
//       display: none !important;
//     }
    
//     /* Show labels only when they have data-color-name attribute */
//     fieldset.product-form__input--pill.color-code-fieldset label[data-color-name] {
//       display: inline-block !important;
//     }
    
//     /* Ensure Colour Code fieldset displays horizontally */
//     fieldset.product-form__input--pill.color-code-fieldset {
//       display: flex !important;
//       flex-wrap: wrap !important;
//       gap: 0.5rem !important;
//       align-items: center !important;
//     }
    
//     /* Original CSS continues below */
//     .color-code-loading {
//       position: relative;
//       opacity: 0.5;
//       pointer-events: none;
//       transition: opacity 0.3s ease-in-out;
//     }
//     .color-code-loading::after {
//       content: '';
//       position: absolute;
//       top: 50%;
//       left: 50%;
//       width: 20px;
//       height: 20px;
//       margin: -10px 0 0 -10px;
//       border: 3px solid rgba(0, 0, 0, 0.1);
//       border-top-color: #666;
//       border-radius: 50%;
//       animation: color-code-spin 0.8s linear infinite;
//       z-index: 10;
//     }
//     .color-code-loading > * {
//       opacity: 0 !important;
//       transition: opacity 0.3s ease-in-out;
//     }
//     .color-code-loading .color-code-text {
//       opacity: 0 !important;
//     }
//     .color-code-loaded {
//       opacity: 1 !important;
//       transition: opacity 0.4s ease-in-out;
//     }
//     .color-code-loaded > * {
//       opacity: 1 !important;
//       transition: opacity 0.4s ease-in-out;
//     }
//     /* Ensure text is visible when not loading */
//     fieldset.product-form__input--pill label:not(.color-code-loading) > * {
//       opacity: 1 !important;
//     }
//     /* Hide disabled radio buttons and their labels */
//     fieldset.product-form__input--pill input[type="radio"].disabled {
//       /* display: none !important; */
//        /* visibility: hidden !important; */
//     }
//     fieldset.product-form__input--pill input[type="radio"].disabled + label {
//       /* display: none !important; */
//        /* visibility: hidden !important; */
//     }
//     /* AGGRESSIVE: Hide ALL labels in Colour Code fieldset immediately */
//     /* Class is added by Liquid template, so this works from the start */
//     fieldset.product-form__input--pill.color-code-fieldset label:not([data-color-name]) {
//       /* display: none !important; */
//       opacity: 0 !important;
//        /* visibility: hidden !important; */
//     }
    
//     /* Show labels once they have color names */
//     fieldset.product-form__input--pill.color-code-fieldset label[data-color-name] {
//       display: inline-block !important;
//       opacity: 1 !important;
//       visibility: visible !important;
//       margin: 0 !important;
//     }
    
//     /* Ensure Colour Code fieldset displays horizontally (not vertically) */
//     fieldset.product-form__input--pill.color-code-fieldset {
//       display: flex !important;
//       flex-wrap: wrap !important;
//       gap: 0.5rem !important;
//       align-items: center !important;
//       min-height: auto !important; /* Let height adjust naturally */
//       margin-bottom: 1.5rem !important; /* Add spacing to prevent overlap with quantity button */
//       margin-top: 0.5rem !important; /* Add top spacing */
//       padding: 0.75rem 0 !important; /* Add vertical padding for better spacing */
//       transition: min-height 0.2s ease-in-out, margin 0.2s ease-in-out !important;
//       clear: both !important; /* Prevent floating elements from overlapping */
//       position: relative !important; /* Ensure proper stacking context */
//       width: 100% !important; /* Ensure full width */
//       box-sizing: border-box !important; /* Include padding in width calculation */
//     }
    
    
//     /* Ensure proper spacing after Colour Code fieldset to prevent overlap */
//     fieldset.product-form__input--pill.color-code-fieldset ~ * {
//       margin-top: 0 !important; /* Let the fieldset's margin-bottom handle spacing */
//     }
    
//     /* Ensure quantity selector and cart button have proper spacing */
//     .product-form__quantity,
//     .quantity,
//     [name="quantity"],
//     .product-form__cart,
//     button[type="submit"][name="add"],
//     .product-form__submit {
//       margin-top: 1rem !important;
//       clear: both !important;
//       position: relative !important;
//     }
    
//     @keyframes color-code-spin {
//       to { transform: rotate(360deg); }
//     }
//   `;
//   document.head.appendChild(style);

//   // Color mapping from Excel file
//   // Format: "[FamilyCode]ColorCode": "Color Name(Chinese)"
//   const colorMap = {
//     // Blue Family [08]
//     "[08]01": "Dark Blue(深蓝)",
//     "[08]02": "Light Blue(浅蓝)",
//     "[08]03": "Blue(蓝色)",
//     "[08]04": "Turquoise(湖水蓝)",
//     "[08]05": "Ice Blue(冰蓝)",
//     "[08]06": "Royal Blue(军蓝)",
//     "[08]07": "Baby Blue(粉蓝)",
//     "[08]08": "Denim Blue(牛仔蓝)",
//     "[08]09": "Sky Blue(天蓝色)",
//     "[08]10": "Coastal Blue(海蓝色)",
//     "[08]11": "Navy(海军蓝)",
//     "[08]12": "Grey blue(灰蓝)",
//     "[08]13": "Teal Blue(蓝绿色)",
//     "[08]14": "Blue Denim(蓝色牛仔色)",
//     "[08]15": "Metallic Bijou Blue(金屬藍色)",
//     "[08]16": "Metallic Future Dusk Blue(金屬暗藍色)",
//     "[08]17": "Metallic Aura Blue(金屬光藍色)",
//     "[08]18": "Skyfall Blue (天空藍)",
    
//     // Add more color families as needed from your Excel file
//     // Red Family [01]
//     "[01]01": "Red(红色)",
//     "[01]02": "Oxblood(血红色)",
//     "[01]03": "Rouge(腮红)",
//     "[01]04": "Scarlet(酒红)",
//     "[01]05": "Burgundy(枣红)",
//     "[01]06": "Dark Fushia(玫瑰红)",
//     "[01]07": "Hot  Red(热红)",
//     "[01]08": "Strawberry Red(草莓红)",
//     "[01]09": "Cabernet(葡萄红)",
//     "[01]10": "Rose Red(玫瑰红)",
//     "[01]11": "Wine(酒红)",
//     "[01]12": "Maroon(褐红色)",
//     "[01]13": "Cherry(樱桃红)",
//     "[01]15": "Peach red(桃红)",
//     "[01]16": "Red Wine(红葡萄酒色)",
//     "[01]17": "Clay Red(粘土红)",
    
//     // Black Family [02]
//     "[02]01": "Black (黑)",
//     "[02]02": "Currant(黑醋栗)",
//     "[02]03": "Ink Black(墨黑色)",
//     "[02]04": "Black Blue(黑蓝色)",
//     "[02]05": "Blacberry Cordia(黑莓)",
//     "[02]06": "Light Black(浅黑)",
//     "[02]07": "Dark Black(暗黑色)",
//     "[02]08": "Black/Gold(黑/金)",
//     "[02]09": "Black/Blue(黑/蓝)",
    
//     // Brown Family [03]
//     "[03]01": "Coal Brown(碳啡)",
//     "[03]02": "Coffee(咖啡)",
//     "[03]03": "Brown(啡色)",
//     "[03]04": "Cappuccino(浅啡)",
//     "[03]05": "Dark Brown(深棕色)",
//     "[03]06": "Khaki(卡其色)",
//     "[03]07": "Camel(骆驼色)",
//     "[03]08": "Sand(沙色)",
//     "[03]09": "Taupe(灰褐色)",
//     "[03]10": "Maroon(栗色)",
//     "[03]11": "Oxford Tan(沙色)",
//     "[03]12": "Caramel(焦糖色)",
//     "[03]13": "Dark Brown(深啡色)",
//     "[03]14": "Cahel(卡赫尔色)",
//     "[03]15": "Khaki Beige(卡其米色)",
//     "[03]16": "Mocha(摩卡色)",
//     "[03]17": "Metallic Desert(金屬沙漠色)",
//     "[03]18": "Khaki Green(卡其绿色)",
    
//     // Green Family [04]
//     "[04]01": "Green(绿色)",
//     "[04]02": "Dark Green(深绿)",
//     "[04]03": "Light Green(浅绿)",
//     "[04]04": "Olive(橄榄绿)",
//     "[04]05": "Mint(薄荷绿)",
//     "[04]06": "Forest Green(森林绿)",
//     "[04]07": "Emerald(翠绿)",
//     "[04]08": "Sage(鼠尾草绿)",
//     "[04]09": "Jade(玉绿)",
//     "[04]10": "Army Green(军绿)",
//     "[04]11": "Lime Green(青柠绿)",
//     "[04]12": "Teal(青绿)",
//     "[04]13": "Pistachio(开心果绿)",
//     "[04]14": "Seafoam(海泡绿)",
//     "[04]15": "Hunter Green(猎人绿)",
//     "[04]16": "Kelly Green(凯利绿)",
//     "[04]17": "Chartreuse(黄绿)",
//     "[04]18": "Malachite(孔雀石绿)",
//     "[04]22": "Metallic Dark Sea Green(金属深绿)",
    
//     // Grey Family [09]
//     "[09]01": "Grey(灰色)",
//     "[09]02": "Light Grey(浅灰)",
//     "[09]03": "Dark Grey(深灰)",
//     "[09]04": "Charcoal(炭灰)",
//     "[09]05": "Silver(银色)",
//     "[09]06": "Slate(石板灰)",
//     "[09]07": "Steel Grey(钢灰)",
//     "[09]08": "Smoke Grey(烟灰)",
//     "[09]09": "Pearl Grey(珍珠灰)",
//     "[09]10": "Graphite(石墨灰)",
//     "[09]11": "Platinum(铂金灰)",
//     "[09]12": "Bungee Cord(大象灰)",
//     "[09]13": "Whitecap Gray(白灰色（米色）)",
//     "[09]14": "Ash Grey(烟灰色)",
//     "[09]15": "Metallic Dark Grey(金屬深灰)",
    
//     // Yellow Family [10]
//     "[10]01": "Yellow(黄色)",
//     "[10]02": "Light Yellow(浅黄)",
//     "[10]03": "Mustard(芥末黃)",
//     "[10]04": "Mellow Yellow(淡黄)",
//     "[10]05": "Cyber Lime(青柠色)",
//     "[10]06": "Apricot(杏色)",
//     "[10]08": "Lemon(柠檬黄)",
//     "[10]09": "Primrose Yellow(樱草黄)",
//     "[10]10": "Dark Yellow(深黄色)",
//     "[10]11": "Dark Apricot(深杏色)",
//     "[10]12": "Dark Apricot Color Contrasts With White(深杏色/撞白色)",
//     "[10]13": "Dawn Yellow (黎明黄)",
//     "[10]14": "Bronze (青銅色)",
//     "[10]97": "Gold(金色)",
//     "[10]98": "Champagne(香槟)",
    
//     // Orange Family [11]
//     "[11]01": "Orange(橙色)",
//     "[11]02": "Lime(酸橙)",
//     "[11]03": "Orange Yellow(橙黄色)",
//     "[11]04": "Sun Orange(陽橙色)",
    
//     // Beige Family [16]
//     "[16]01": "Beige(米色)",
//     "[16]02": "Oyster Beige(牡蠣米色)",
//     "[16]03": "Latte(拿铁色)",
    
//     // Purple Family [24]
//     "[24]01": "Purple(紫色)",
//     "[24]02": "Lavender(薰衣草紫)",
//     "[24]03": "Violet(紫罗兰)",
//     "[24]04": "Plum(梅子紫)",
//     "[24]05": "Mauve(淡紫色)",
//     "[24]06": "Amethyst(紫水晶)",
//     "[24]07": "Grape(葡萄紫)",
//     "[24]08": "Eggplant(茄子紫)",
//     "[24]09": "Orchid(兰花紫)",
//     "[24]10": "Metallic Purple(金屬紫)",
//     "[24]11": "Lilac(丁香紫)",
    
//     // Pink Family [33]
//     "[33]01": "Pink(粉色)",
//     "[33]02": "Rose(玫瑰粉)",
//     "[33]03": "Blush(腮红粉)",
//     "[33]04": "Coral(珊瑚粉)",
//     "[33]05": "Salmon(鲑鱼粉)",
//     "[33]06": "Peach(桃粉)",
//     "[33]07": "Bubblegum(泡泡糖粉)",
//     "[33]08": "Fuchsia(紫红)",
//     "[33]09": "Magenta(洋红)",
//     "[33]10": "Hot Pink(热粉)",
//     "[33]15": "Sakura Pink(樱花粉色)",
    
//     // White Family [35]
//     "[35]01": "White(白色)",
//     "[35]02": "Ivory(象牙白)",
//     "[35]03": "Off White(米白色)",
//     "[35]04": "Off White With Orange(米白色撞橙色)",
//     "[35]05": "Metallic Pearl(金屬珍珠白色)",
//     "[35]82": "Pearl White(珍珠白)",
    
//     // Misc Family [36]
//     "[36]01": "Multi(杂色)",
//     "[36]02": "Clear(透明)",
//     "[36]03": "Frosted(半透明)",
//     "[36]04": "Black/White(黑白)",
//     "[36]05": "Black/Red(黑/红)",
//     "[36]07": "Black/Grey(黑/灰)",
//     "[36]08": "Grey/Pink(灰/粉)",
//     "[36]09": "Black/Purple(黑/紫)",
//     "[36]10": "Black/Orange(黑/橙)",
//     "[36]11": "Black/Green(黑/綠)",
//     "[36]12": "Blue/Grey(蓝/灰)",
//     "[36]13": "Beige/Yellow(杏/黄)",
//     "[36]14": "Black/Pink(黑/粉)",
//     "[36]15": "Black/Dark blue(黑/深蓝)",
//     "[36]16": "Yellow/Gold(杏/金)",
//     "[36]17": "Dark blue/Gold(深蓝/金)",
//     "[36]18": "Blue/White(藍/白)",
//     "[36]19": "White/Dark Blue(白/深藍)",
//     "[36]20": "Light Blue/Multi(淺藍/彩色)"
//   };

//   // Family code mapping
//   const familyCodeMap = {
//     "Blue(藍)": "08",
//     "White(白)": "35",
//     "Green(綠)": "04",
//     "Purple(紫)": "24",
//     "Orange(橙)": "11",
//     "Red(紅)": "01",
//     "Black(黑)": "02",
//     "Brown(啡)": "03",
//     "Grey(灰)": "09",
//     "Yellow(黃)": "10",
//     "Beige(米)": "16",
//     "Pink(粉紅)": "33",
//     "Misc(杂色)": "36",
//     "Hardware (配件颜)": "37",
//     "Unknown (無顏)": "UN"
//   };

//   /**
//    * Get color name from family and code
//    */
//   function getColorName(familyName, colorCode) {
//     const familyCode = familyCodeMap[familyName];
//     if (!familyCode) {
//       console.warn('Family not found:', familyName);
//       return null;
//     }
    
//     const finalCode = `[${familyCode}]${String(colorCode).padStart(2, '0')}`;
//     return colorMap[finalCode] || null;
//   }

//   /**
//    * Get the current variant's color family from Shopify variant data
//    * Returns the family name or null if not found
//    */
//   function getVariantColorFamily() {
//     try {
//       // First, try to get from data-selected-variant script (most reliable)
//       const selectedVariantScript = document.querySelector('script[type="application/json"][data-selected-variant]');
//       if (selectedVariantScript) {
//         try {
//           const variantData = JSON.parse(selectedVariantScript.textContent);
//           if (variantData) {
//             // Check option1 first (usually the color/colour family)
//             const variantColor = variantData.option1 || variantData.option2 || variantData.option3 || '';
//             if (variantColor) {
//               const matchedFamily = matchFamilyName(variantColor);
//               if (matchedFamily) {
//                 console.log('[Color Code Replacer] Found variant color family from data-selected-variant:', matchedFamily, '(option1:', variantColor, ')');
//                 return matchedFamily;
//               }
//             }
//           }
//         } catch (e) {
//           console.warn('[Color Code Replacer] Error parsing data-selected-variant:', e);
//         }
//       }
      
//       // Try to get variant from Shopify product form
//       const variantSelect = document.querySelector('select[name="id"], select[data-product-select]');
//       if (variantSelect && variantSelect.value) {
//         const variantId = parseInt(variantSelect.value);
        
//         // Try to get variant data from Shopify product JSON
//         const productJson = document.querySelector('script[type="application/json"][data-product-json]');
//         if (productJson) {
//           try {
//             const productData = JSON.parse(productJson.textContent);
//             if (productData && productData.variants) {
//               const variant = productData.variants.find(v => v.id === variantId);
//               if (variant) {
//                 // Check variant options - try option1, option2, option3, and title
//                 const variantColor = variant.option1 || variant.option2 || variant.option3 || variant.title || '';
                
//                 const matchedFamily = matchFamilyName(variantColor);
//                 if (matchedFamily) {
//                   console.log('[Color Code Replacer] Found variant color family from product JSON:', matchedFamily, '(variant:', variantColor, ')');
//                   return matchedFamily;
//                 }
//               }
//             }
//           } catch (e) {
//             console.warn('[Color Code Replacer] Error parsing product JSON:', e);
//           }
//         }
        
//         // Alternative: Check if variant selector has data attributes or text
//         const variantOption = variantSelect.querySelector(`option[value="${variantId}"]`);
//         if (variantOption) {
//           const variantText = variantOption.textContent.trim();
//           const matchedFamily = matchFamilyName(variantText);
//           if (matchedFamily) {
//             console.log('[Color Code Replacer] Found variant family from option text:', matchedFamily, '(text:', variantText, ')');
//             return matchedFamily;
//           }
//         }
//       }
      
//       // Fallback: Check if there's a selected Colour Code that can help determine the family
//       // This is useful if variant doesn't have clear color info but Colour Code is selected
//       const colorCodeFieldset = document.querySelector('fieldset.product-form__input--pill.color-code-fieldset');
//       if (colorCodeFieldset) {
//         const checkedColorCode = colorCodeFieldset.querySelector('input[type="radio"]:checked');
//         if (checkedColorCode) {
//           const colorCode = checkedColorCode.value;
//           // Try to find which family this color code belongs to by checking all families
//           // and seeing which one has a match
//           for (const [familyName, familyCode] of Object.entries(familyCodeMap)) {
//             const finalCode = `[${familyCode}]${String(colorCode).padStart(2, '0')}`;
//             if (colorMap[finalCode]) {
//               console.log('[Color Code Replacer] Inferred family from selected Colour Code:', familyName, '(code:', colorCode, ')');
//               return familyName;
//             }
//           }
//         }
//       }
//     } catch (e) {
//       console.warn('[Color Code Replacer] Error getting variant color family:', e);
//     }
//     return null;
//   }

//   /**
//    * Match family name from label to familyCodeMap key
//    * Handles cases where label shows "Red" but map has "Red(紅)"
//    */
//   function matchFamilyName(labelText) {
//     if (!labelText) return null;
    
//     const trimmed = labelText.trim();
    
//     // Try exact match first
//     if (familyCodeMap[trimmed]) {
//       return trimmed;
//     }
    
//     // Try partial match - check if label text matches the base name (before parentheses)
//     for (const [familyName, familyCode] of Object.entries(familyCodeMap)) {
//       const familyBase = familyName.split('(')[0].trim(); // Get "Red" from "Red(紅)"
//       const labelBase = trimmed.split('(')[0].trim(); // Get "Red" from "Red" or "Red(紅)"
      
//       // Case-insensitive match
//       if (familyBase.toLowerCase() === labelBase.toLowerCase() || 
//           trimmed.toLowerCase() === familyBase.toLowerCase()) {
//         console.log('[Color Code Replacer] Matched label "' + trimmed + '" to family "' + familyName + '"');
//         return familyName;
//       }
//     }
    
//     return null;
//   }

//   /**
//    * Get selected Colour Family from the form
//    * Returns the family name or null if not selected
//    */
//   function getSelectedColourFamily() {
//     // First, check if user manually selected a Colour Family
//     const fieldsets = document.querySelectorAll('fieldset.product-form__input--pill');
//     for (const fieldset of fieldsets) {
//       const legend = fieldset.querySelector('legend');
//       if (legend) {
//         const legendText = legend.textContent.trim();
//         if (legendText === 'Colour Family' || legendText === 'Color Family' || legendText === 'Colour') {
//           // Find the checked radio button
//           const checkedRadio = fieldset.querySelector('input[type="radio"]:checked');
//           if (checkedRadio) {
//             // First try the radio button value (e.g., value="Red")
//             const radioValue = checkedRadio.value;
//             if (radioValue) {
//               const matchedFamily = matchFamilyName(radioValue);
//               if (matchedFamily) {
//                 console.log('[Color Code Replacer] Found selected Colour Family from radio value:', matchedFamily, '(value:', radioValue, ')');
//                 return matchedFamily;
//               }
//             }
            
//             // Fallback: Get the label text for the checked radio
//             const label = fieldset.querySelector(`label[for="${checkedRadio.id}"]`);
//             if (label) {
//               const textNode = Array.from(label.childNodes).find(n => n.nodeType === 3);
//               const familyNameText = textNode?.textContent?.trim();
//               if (familyNameText) {
//                 // Use matchFamilyName to handle "Red" -> "Red(紅)" matching
//                 const matchedFamily = matchFamilyName(familyNameText);
//                 if (matchedFamily) {
//                   console.log('[Color Code Replacer] Found selected Colour Family from label:', matchedFamily, '(label:', familyNameText, ')');
//                   return matchedFamily;
//                 }
//               }
//             }
//           }
//         }
//       }
//     }
    
//     // If no manual selection, try to detect from current variant
//     const variantFamily = getVariantColorFamily();
//     if (variantFamily) {
//       console.log('[Color Code Replacer] Using variant color family:', variantFamily);
//       return variantFamily;
//     }
    
//     return null;
//   }

//   /**
//    * Find color name by trying all families (preload approach)
//    * Returns the first match found across all families
//    */
//   function findColorNameFromAllFamilies(colorCode) {
//     const paddedCode = String(colorCode).padStart(2, '0');
    
//     // Try each family code
//     for (const [familyName, familyCode] of Object.entries(familyCodeMap)) {
//       const finalCode = `[${familyCode}]${paddedCode}`;
//       if (colorMap[finalCode]) {
//         return {
//           colorName: colorMap[finalCode],
//           familyName: familyName,
//           familyCode: familyCode
//         };
//       }
//     }
    
//     return null;
//   }

//   /**
//    * Find color name, prioritizing selected Colour Family
//    * If a Colour Family is selected, use that family first
//    * Otherwise, search all families
//    */
//   function findColorName(colorCode) {
//     const selectedFamily = getSelectedColourFamily();
    
//     // If a Colour Family is selected, try that family first
//     if (selectedFamily) {
//       const colorName = getColorName(selectedFamily, colorCode);
//       if (colorName) {
//         const familyCode = familyCodeMap[selectedFamily];
//         return {
//           colorName: colorName,
//           familyName: selectedFamily,
//           familyCode: familyCode
//         };
//       }
//     }
    
//     // Fall back to searching all families
//     return findColorNameFromAllFamilies(colorCode);
//   }

//   /**
//    * Show loading animation on label
//    */
//   function showLoading(label) {
//     if (!label.classList.contains('color-code-loading')) {
//       label.classList.add('color-code-loading');
//       label.classList.remove('color-code-loaded');
//     }
//   }

//   /**
//    * Hide loading animation on label
//    */
//   function hideLoading(label) {
//     if (label) {
//       label.classList.remove('color-code-loading');
//       // Add loaded class for fade-in effect
//       label.classList.add('color-code-loaded');
//       // Remove loaded class after animation completes
//       setTimeout(() => {
//         if (label) {
//           label.classList.remove('color-code-loaded');
//         }
//       }, 400);
//     }
//   }

//   /**
//    * Show loading on all color code labels
//    */
//   function showLoadingOnAllLabels(colorCodeFieldset) {
//     const labels = colorCodeFieldset.querySelectorAll('label');
//     labels.forEach(label => {
//       showLoading(label);
//     });
//   }

//   /**
//    * Hide loading on all color code labels
//    */
//   function hideLoadingOnAllLabels(colorCodeFieldset) {
//     const labels = colorCodeFieldset.querySelectorAll('label');
//     labels.forEach(label => {
//       hideLoading(label);
//     });
//   }

//   /**
//    * Hide disabled radio buttons and their labels
//    */
//   function hideDisabledOptions() {
//     const fieldsets = document.querySelectorAll('fieldset.product-form__input--pill');
//     fieldsets.forEach(fieldset => {
//       const legend = fieldset.querySelector('legend');
//       if (legend && (legend.textContent.includes('Colour Code') || legend.textContent.includes('Color Code'))) {
//         const disabledInputs = fieldset.querySelectorAll('input[type="radio"].disabled');
//         disabledInputs.forEach(input => {
//           // Hide the input
//           if (input) {
//             input.style.display = 'none';
//             input.style.visibility = 'hidden';
//             // Hide the associated label
//             const label = fieldset.querySelector(`label[for="${input.id}"]`);
//             if (label) {
//               label.style.display = 'none';
//               label.style.visibility = 'hidden';
//             }
//           }
//         });
//       }
//     });
//   }

//   /**
//    * Update Colour Code pills
//    * @param {boolean} force - If true, bypass throttle (for variant changes)
//    * @param {boolean} showLoadingAnimation - If true, show loading spinner (for variant changes)
//    */
//   function updateColorCodePills(force = false, showLoadingAnimation = false) {
//     // If forced and isUpdating is true, reset it to allow the forced update
//     // This is important for initial page loads and variant changes
//     if (force && isUpdating) {
//       console.warn('[Color Code Replacer] Forced update requested while update in progress, resetting isUpdating flag');
//       isUpdating = false;
//     }
    
//     // Prevent concurrent updates, but allow forced updates to bypass
//     if (isUpdating && !force) {
//       console.log('[Color Code Replacer] Update already in progress, skipping...');
//       return;
//     }
    
//     const now = Date.now();
//     if (!force && now - lastUpdateTime < UPDATE_THROTTLE) {
//       console.log('[Color Code Replacer] Throttled, last update was', now - lastUpdateTime, 'ms ago');
//       return;
//     }
    
//     console.log('[Color Code Replacer] Starting update...', force ? '(forced)' : '');
    
//     isUpdating = true;
//     lastUpdateTime = now;
    
//     try {
//       // Find Colour Code fieldset
//       const fieldsets = document.querySelectorAll('fieldset.product-form__input--pill');
//       let colorCodeFieldset = null;
//       let colorFamilyFieldset = null;
      
//       fieldsets.forEach(fieldset => {
//         const legend = fieldset.querySelector('legend');
//         if (legend) {
//           const legendText = legend.textContent.trim();
//           if (legendText === 'Colour Code' || legendText === 'Color Code') {
//             colorCodeFieldset = fieldset;
//             // Add specific class to Colour Code fieldset so CSS only targets it
//             fieldset.classList.add('color-code-fieldset');
//             // CSS handles hiding labels with numbers automatically
//           } else if (legendText === 'Colour Family' || legendText === 'Color Family' || legendText === 'Colour') {
//             colorFamilyFieldset = fieldset;
//             // Update the label to "Colour" if it's still "Colour Family"
//             if (legendText === 'Colour Family' || legendText === 'Color Family') {
//               legend.textContent = 'Colour';
//             }
//           }
//         }
//       });
      
//       if (!colorCodeFieldset) {
//         console.warn('[Color Code Replacer] Colour Code fieldset not found');
//         isUpdating = false;
//         return;
//       }
      
//       console.log('[Color Code Replacer] Found Colour Code fieldset');
      
//       // Fieldset stays visible - only labels are hidden by CSS
//       // No need to hide/show the entire fieldset anymore
      
//       // CRITICAL: Hide ALL labels immediately to prevent numbers from showing
//       // This happens synchronously before any async processing
//       const allLabels = colorCodeFieldset.querySelectorAll('label');
//       allLabels.forEach(label => {
//         // Check if label text is a number
//         const textNode = Array.from(label.childNodes).find(n => n.nodeType === 3);
//         const text = textNode?.textContent?.trim();
//         // Hide if it's a number OR if it doesn't have data-color-name
//         if ((text && /^\d+$/.test(text)) || !label.dataset.colorName) {
//           label.style.display = 'none';
//         }
//       });
//       console.log('[Color Code Replacer] Hid', allLabels.length, 'labels immediately');
      
//       // Update each Colour Code pill - PRELOAD ALL from all families
//       const radioInputs = colorCodeFieldset.querySelectorAll('input[type="radio"]');
//       console.log('[Color Code Replacer] Found', radioInputs.length, 'Colour Code options - preloading all...');
      
//       // Only show loading animation if explicitly requested (for variant changes)
//       if (showLoadingAnimation) {
//         showLoadingOnAllLabels(colorCodeFieldset);
//       }
      
//       // Process immediately without delay to prevent numbers from showing
//       // Use requestAnimationFrame to ensure DOM is ready but process ASAP
//       requestAnimationFrame(() => {
//         // Re-query in case Shopify replaced elements
//         let currentFieldset = document.querySelector('fieldset.product-form__input--pill.color-code-fieldset');
//         if (!currentFieldset) {
//           const fieldsets = document.querySelectorAll('fieldset.product-form__input--pill');
//           fieldsets.forEach(fieldset => {
//             const legend = fieldset.querySelector('legend');
//             if (legend && (legend.textContent.includes('Colour Code') || legend.textContent.includes('Color Code'))) {
//               currentFieldset = fieldset;
//               fieldset.classList.add('color-code-fieldset');
//               // CSS handles hiding labels with numbers automatically
//             }
//           });
//         } else {
//           // Keep hidden until processed
//           // CSS handles hiding labels automatically
//         }
        
//         // Update the reference
//         if (currentFieldset) {
//           colorCodeFieldset = currentFieldset;
//         }
        
//         if (!colorCodeFieldset) {
//           console.warn('[Color Code Replacer] Colour Code fieldset not found after delay');
//           isUpdating = false;
//           return;
//         }
        
//         // Re-query radio inputs in case they were replaced
//         const currentRadioInputs = colorCodeFieldset.querySelectorAll('input[type="radio"]');
//         let updated = 0;
//         let skipped = 0;
        
//         currentRadioInputs.forEach((radio, index) => {
//           const colorCode = radio.value;
//           const label = colorCodeFieldset.querySelector(`label[for="${radio.id}"]`);
          
//           if (!label) {
//             console.warn('[Color Code Replacer] No label found for radio:', radio.id);
//             return;
//           }
          
//           // Try to find color name, prioritizing selected Colour Family
//           const colorInfo = findColorName(colorCode);
          
//           if (colorInfo) {
//             const colorName = colorInfo.colorName;
//             // Check current text
//             const textNode = Array.from(label.childNodes).find(n => n.nodeType === 3);
//             const currentText = textNode?.textContent?.trim();
            
//             console.log(`[Color Code Replacer] Code ${colorCode}: current="${currentText}", target="${colorName}"`);
            
//             // IMPORTANT: Set data attributes FIRST so CSS can show the label immediately
//             // This prevents the number from being visible
//             label.dataset.colorName = colorName;
//             label.dataset.colorFamily = colorInfo.familyName;
//             label.dataset.familyCode = colorInfo.familyCode;
//             label.dataset.originalCode = colorCode;
            
//             // CRITICAL: Show label immediately by removing inline display:none
//             // This happens synchronously right after setting data attribute
//             label.style.display = '';
            
//             // Always update if color name is different OR if it's showing a number
//             // This prevents reverting from words to numbers
//             if (currentText !== colorName || (currentText && /^\d+$/.test(currentText))) {
//               console.log(`[Color Code Replacer] Updating ${colorCode} from "${currentText}" to "${colorName}"`);
              
//               // Preserve visually-hidden span
//               const visuallyHidden = label.querySelector('.visually-hidden, .label-unavailable');
              
//               // Use a more stable approach - replace text node directly instead of innerHTML
//               if (textNode) {
//                 textNode.textContent = colorName;
//               } else {
//                 // No text node, create one
//                 label.innerHTML = '';
//                 label.appendChild(document.createTextNode(colorName));
//                 if (visuallyHidden) {
//                   label.appendChild(visuallyHidden.cloneNode(true));
//                 }
//               }
              
//               // Hide loading after update (only if we showed it) and ensure text is visible
//               if (showLoadingAnimation) {
//                 setTimeout(() => {
//                   hideLoading(label);
//                   // Force text visibility
//                   const updatedTextNode = Array.from(label.childNodes).find(n => n.nodeType === 3);
//                   if (updatedTextNode) {
//                     updatedTextNode.style.opacity = '1';
//                   }
//                 }, 150 + (index * 30)); // Longer delay, more stagger
//               } else {
//                 // Ensure text is visible even without loading animation
//                 const updatedTextNode = Array.from(label.childNodes).find(n => n.nodeType === 3);
//                 if (updatedTextNode) {
//                   updatedTextNode.style.opacity = '1';
//                 }
//               }
              
//               updated++;
//             } else {
//               console.log(`[Color Code Replacer] Code ${colorCode} already correct, skipping`);
//               skipped++;
//               // Still update the data attributes to track info
//               label.dataset.colorName = colorName;
//               label.dataset.colorFamily = colorInfo.familyName;
//               label.dataset.familyCode = colorInfo.familyCode;
//               // Ensure label is visible (in case it was hidden)
//               label.style.display = '';
              
//               // Hide loading even if already correct (only if we showed it)
//               if (showLoadingAnimation) {
//                 setTimeout(() => {
//                   hideLoading(label);
//                   // Force text visibility
//                   const updatedTextNode = Array.from(label.childNodes).find(n => n.nodeType === 3);
//                   if (updatedTextNode) {
//                     updatedTextNode.style.opacity = '1';
//                   }
//                 }, 150 + (index * 30));
//               }
//             }
//           } else {
//             // No color name found for this code
//             const textNode = Array.from(label.childNodes).find(n => n.nodeType === 3);
//             const currentText = textNode?.textContent?.trim();
            
//             // Check if it's currently showing a number
//             if (currentText && /^\d+$/.test(currentText)) {
//               // Try to find if this code exists in ANY family (with different padding)
//               let foundMatch = false;
//               for (let pad = 0; pad <= 2; pad++) {
//                 const testCode = String(colorCode).padStart(2 + pad, '0');
//                 for (const [familyName, familyCode] of Object.entries(familyCodeMap)) {
//                   const finalCode = `[${familyCode}]${testCode}`;
//                   if (colorMap[finalCode]) {
//                     console.log(`[Color Code Replacer] Found match for code "${colorCode}" as "${finalCode}"`);
//                     const colorName = colorMap[finalCode];
//                     // Set data attributes FIRST so CSS can show the label
//                     label.dataset.colorName = colorName;
//                     label.dataset.colorFamily = familyName;
//                     label.dataset.familyCode = familyCode;
//                     label.dataset.originalCode = colorCode;
//                     // Show label immediately
//                     label.style.display = '';
//                     if (textNode) {
//                       textNode.textContent = colorName;
//                       textNode.style.opacity = '1';
//                     }
//                     foundMatch = true;
//                     updated++;
//                     break;
//                   }
//                 }
//                 if (foundMatch) break;
//               }
              
//               if (!foundMatch) {
//                 // If we have a stored color name from before, use it
//                 if (label.dataset.colorName) {
//                   console.log(`[Color Code Replacer] Restoring stored color name for ${colorCode}`);
//                   // Show label immediately
//                   label.style.display = '';
//                   if (textNode) {
//                     textNode.textContent = label.dataset.colorName;
//                     textNode.style.opacity = '1';
//                   }
//                 } else {
//                   // No mapping found - log it so user can add it
//                   console.warn(`[Color Code Replacer] ⚠️ No color name found for code "${colorCode}" in any family. Please add this code to colorMap.`);
//                   console.warn(`[Color Code Replacer] Current text: "${currentText}", Radio value: "${colorCode}"`);
//                   // Keep it as number since no mapping exists
//                 }
//               }
//             } else {
//               // Already showing a color name, keep it
//               console.log(`[Color Code Replacer] Code ${colorCode} already has color name: "${currentText}"`);
//             }
            
//             // Hide loading even if no color name found (only if we showed it)
//             if (showLoadingAnimation) {
//               setTimeout(() => {
//                 hideLoading(label);
//               }, 150 + (index * 30));
//             }
//           }
//         });
      
//         // Ensure all loading is hidden after delay (fallback, only if we showed it)
//         if (showLoadingAnimation) {
//           setTimeout(() => {
//             hideLoadingOnAllLabels(colorCodeFieldset);
//             // Force all text to be visible
//             const allLabels = colorCodeFieldset.querySelectorAll('label');
//             allLabels.forEach(lbl => {
//               const txtNode = Array.from(lbl.childNodes).find(n => n.nodeType === 3);
//               if (txtNode) {
//                 txtNode.style.opacity = '1';
//               }
//             });
//           }, 150 + (currentRadioInputs.length * 30) + 200);
//         }
        
//         console.log(`[Color Code Replacer] Update complete: ${updated} updated, ${skipped} skipped`);
        
//         // Hide disabled options after update
//         hideDisabledOptions();
        
//         // Fieldset stays visible - labels are shown automatically when data-color-name is set
//         // No need to show/hide the fieldset anymore - CSS handles label visibility
//         console.log('[Color Code Replacer] All color codes processed - labels will show automatically via CSS');
//       }, showLoadingAnimation ? 200 : 0); // Longer delay for variant changes to let Shopify finish
//     } finally {
//       isUpdating = false;
//       console.log('[Color Code Replacer] Update finished, isUpdating set to false');
//     }
//   }

// // Track if update is in progress to prevent loops
// let isUpdating = false;
// let lastUpdateTime = 0;
// const UPDATE_THROTTLE = 500; // Minimum 500ms between updates
// let variantChangeTimeout = null;

//   /**
//    * Change "Colour Family" to "Colour" on the front end
//    */
//   function updateColourFamilyLabel() {
//     const fieldsets = document.querySelectorAll('fieldset.product-form__input--pill');
//     fieldsets.forEach(fieldset => {
//       const legend = fieldset.querySelector('legend');
//       if (legend) {
//         const legendText = legend.textContent.trim();
//         if (legendText === 'Colour Family' || legendText === 'Color Family') {
//           legend.textContent = 'Colour';
//           console.log('[Color Code Replacer] Changed "Colour Family" to "Colour"');
//         }
//       }
//     });
//   }

//   // Run when DOM is ready
//   function init() {
//     // Change "Colour Family" to "Colour" on the front end
//     updateColourFamilyLabel();
    
//     // Hide Colour Family fieldset if user only wants Colour Code
//     // Uncomment the next lines if you want to hide the Colour Family fieldset
//     /*
//     setTimeout(() => {
//       const fieldsets = document.querySelectorAll('fieldset.product-form__input--pill');
//       fieldsets.forEach(fieldset => {
//         const legend = fieldset.querySelector('legend');
//         if (legend && (legend.textContent.includes('Colour Family') || legend.textContent.includes('Color Family'))) {
//           fieldset.style.display = 'none';
//           console.log('[Color Code Replacer] Hidden Colour Family fieldset');
//         }
//       });
//     }, 500);
//     */
    
//     // Listen for Shopify variant changes (multiple event types)
//     const variantChangeHandler = () => {
//       console.log('[Color Code Replacer] Variant change detected!');
//       // Clear any pending timeouts to prevent glitching
//       if (variantChangeTimeout) {
//         clearTimeout(variantChangeTimeout);
//       }
//       // Update immediately with loading animation (force bypass throttle) and then retry multiple times
//       updateColorCodePills(true, true); // Show loading animation on variant changes
//       hideDisabledOptions(); // Hide disabled options
//       [50, 150, 300, 600, 1000, 2000].forEach((delay, index) => {
//         variantChangeTimeout = setTimeout(() => {
//           // Only show loading on first retry, not all of them
//           updateColorCodePills(true, index === 0);
//           hideDisabledOptions(); // Hide disabled options
//         }, delay);
//       });
//     };
    
//     // Listen for various Shopify variant change events
//     document.addEventListener('variant:change', variantChangeHandler);
//     document.addEventListener('variantChange', variantChangeHandler);
//     document.addEventListener('shopify:section:load', variantChangeHandler);
    
//     // Listen for changes on variant selector (if it exists)
//     const variantSelectors = document.querySelectorAll('select[name="id"], select[data-product-select], .product-form__input--dropdown select');
//     variantSelectors.forEach(select => {
//       select.addEventListener('change', variantChangeHandler);
//     });
    
//     // Watch for new variant selectors being added
//     if (typeof MutationObserver !== 'undefined') {
//       const variantObserver = new MutationObserver((mutations) => {
//         mutations.forEach(mutation => {
//           mutation.addedNodes.forEach(node => {
//             if (node.nodeType === 1) { // Element node
//               const newSelects = node.querySelectorAll ? node.querySelectorAll('select[name="id"], select[data-product-select], .product-form__input--dropdown select') : [];
//               newSelects.forEach(select => {
//                 select.addEventListener('change', variantChangeHandler);
//               });
//               // Also check if node itself is a select
//               if (node.tagName === 'SELECT' && (node.name === 'id' || node.hasAttribute('data-product-select'))) {
//                 node.addEventListener('change', variantChangeHandler);
//               }
//             }
//           });
//         });
//       });
      
//       if (document.body) {
//         variantObserver.observe(document.body, {
//           childList: true,
//           subtree: true
//         });
//       }
//     }
    
//     // ULTRA-AGGRESSIVE preload - start immediately and very frequently
//     // Try immediately and then at very short intervals to catch numbers before they show
//     // Use force=true for initial loads to bypass throttling and isUpdating checks
//     const preloadDelays = [0, 10, 25, 50, 75, 100, 150, 200, 300, 500, 750, 1000, 1500, 2000, 3000];
//     preloadDelays.forEach((delay, index) => {
//       setTimeout(() => {
//         console.log(`[Color Code Replacer] Preload attempt ${index + 1} after ${delay}ms`);
//         // Use force=true for initial loads to ensure they run even if isUpdating is true
//         updateColorCodePills(true, false); // Force update, no loading animation on initial load
//         hideDisabledOptions(); // Hide disabled options
//       }, delay);
//     });
    
//     // EXTRA AGGRESSIVE: Also run immediately in a loop for the first second
//     let immediateAttempts = 0;
//     const immediateInterval = setInterval(() => {
//       immediateAttempts++;
//       if (immediateAttempts > 20) { // Run 20 times in first second (every 50ms)
//         clearInterval(immediateInterval);
//         return;
//       }
//       // Use force=true to ensure updates run on initial load
//       updateColorCodePills(true, false);
//       hideDisabledOptions();
//     }, 50); // Every 50ms for first second
    
//     // Also watch for when the fieldset is first added to DOM (immediate update)
//     if (typeof MutationObserver !== 'undefined') {
//       const preloadObserver = new MutationObserver((mutations) => {
//         for (const mutation of mutations) {
//           for (const node of mutation.addedNodes) {
//             if (node.nodeType === 1) { // Element node
//               const fieldset = node.tagName === 'FIELDSET' ? node : 
//                 (node.querySelector?.('fieldset.product-form__input--pill') || 
//                  node.closest?.('fieldset.product-form__input--pill'));
//               if (fieldset) {
//                 const legend = fieldset.querySelector('legend');
//                 if (legend) {
//                   const legendText = legend.textContent.trim();
//                   // Update Colour Family label
//                   if (legendText === 'Colour Family' || legendText === 'Color Family') {
//                     legend.textContent = 'Colour';
//                     console.log('[Color Code Replacer] Changed "Colour Family" to "Colour"');
//                   }
//                   // Handle Colour Code fieldset
//                   if (legendText === 'Colour Code' || legendText === 'Color Code') {
//                     console.log('[Color Code Replacer] Colour Code fieldset detected in DOM, hiding and updating immediately!');
//                     // Add class to fieldset for CSS targeting
//                     fieldset.classList.add('color-code-fieldset');
//                     // Fieldset stays visible - only labels are hidden
                    
//                     // CRITICAL: Hide ALL labels immediately (synchronously, no delay)
//                     const labels = fieldset.querySelectorAll('label');
//                     labels.forEach(label => {
//                       // Check if label text is a number
//                       const textNode = Array.from(label.childNodes).find(n => n.nodeType === 3);
//                       const text = textNode?.textContent?.trim();
//                       // Hide if it's a number OR if it doesn't have data-color-name
//                       if ((text && /^\d+$/.test(text)) || !label.dataset.colorName) {
//                         label.style.display = 'none';
//                       }
//                     });
//                     console.log(`[Color Code Replacer] Immediately hid ${labels.length} labels`);
                    
//                     // Update immediately when fieldset appears
//                     requestAnimationFrame(() => {
//                       updateColorCodePills(true, false); // Force update, no loading animation
//                       hideDisabledOptions();
//                     });
                    
//                     // Also try again after a short delay to ensure it runs
//                     setTimeout(() => {
//                       updateColorCodePills(true, false);
//                       hideDisabledOptions();
//                     }, 100);
//                   }
//                 }
//               }
//             }
//           }
//         }
//       });
      
//       // Start observing immediately (before DOMContentLoaded)
//       if (document.body) {
//         preloadObserver.observe(document.body, {
//           childList: true,
//           subtree: true
//         });
//       } else {
//         // If body doesn't exist yet, wait for it
//         const bodyObserver = new MutationObserver(() => {
//           if (document.body) {
//             preloadObserver.observe(document.body, {
//               childList: true,
//               subtree: true
//             });
//             bodyObserver.disconnect();
//           }
//         });
//         bodyObserver.observe(document.documentElement, {
//           childList: true
//         });
//       }
//     }
    
//     // Initial hide of disabled options
//     setTimeout(() => {
//       hideDisabledOptions();
//     }, 100);
    
//     // Listen for any changes to Colour Code fieldset (to catch reverts)
//     document.addEventListener('change', (e) => {
//       const target = e.target;
//       if (target.type === 'radio') {
//         const fieldset = target.closest('fieldset.product-form__input--pill');
//         if (fieldset) {
//           const legend = fieldset.querySelector('legend');
//           if (legend) {
//             const legendText = legend.textContent.trim();
//             // Handle Colour Family changes - update Colour Code pills
//             if (legendText === 'Colour Family' || legendText === 'Color Family' || legendText === 'Colour') {
//               console.log('[Color Code Replacer] Colour Family changed, updating Colour Code pills...');
//               // Update Colour Code pills when family changes
//               setTimeout(() => {
//                 updateColorCodePills(true, false); // Force update, no loading animation
//               }, 100);
//             }
//             // Handle Colour Code changes
//             else if (legendText.includes('Colour Code') || legendText.includes('Color Code')) {
//               fieldset.classList.add('color-code-fieldset');
//               console.log('[Color Code Replacer] Colour Code changed, checking for reverts...');
//               // Check if labels got reverted and re-apply
//               setTimeout(() => {
//                 updateColorCodePills();
//               }, 100);
//             }
//           }
//         }
//       }
//     });
    
//     // Listen for clicks on Colour Code and Colour Family radios (to catch reverts and family changes)
//     document.addEventListener('click', (e) => {
//       const target = e.target;
//       if (target.type === 'radio' || target.closest('input[type="radio"]')) {
//         const radio = target.type === 'radio' ? target : target.closest('input[type="radio"]');
//         if (radio) {
//           const fieldset = radio.closest('fieldset.product-form__input--pill');
//           if (fieldset) {
//             const legend = fieldset.querySelector('legend');
//             if (legend) {
//               const legendText = legend.textContent.trim();
//               // Handle Colour Family clicks - update Colour Code pills dynamically
//               if (legendText === 'Colour Family' || legendText === 'Color Family' || legendText === 'Colour') {
//                 console.log('[Color Code Replacer] Colour Family clicked, updating Colour Code pills dynamically...');
//                 // Update Colour Code pills when family is clicked (with slight delay to ensure radio is checked)
//                 setTimeout(() => {
//                   updateColorCodePills(true, false); // Force update, no loading animation
//                 }, 150);
//               }
//               // Handle Colour Code clicks
//               else if (legendText.includes('Colour Code') || legendText.includes('Color Code')) {
//                 fieldset.classList.add('color-code-fieldset');
//                 // CSS handles hiding labels automatically
//                 console.log('[Color Code Replacer] Colour Code clicked, checking for reverts...');
//                 setTimeout(() => {
//                   updateColorCodePills();
//                 }, 100);
//               }
//             }
//           }
//         }
//       }
//     });
    
//     // Watch for DOM changes and re-apply if labels get reverted
//     if (typeof MutationObserver !== 'undefined') {
//       const observer = new MutationObserver((mutations) => {
//         let shouldUpdate = false;
//         let newElementsAdded = false;
        
//         for (const mutation of mutations) {
//           const target = mutation.target;
          
//           // Check if new nodes were added (variant change likely replaced DOM)
//           if (mutation.addedNodes && mutation.addedNodes.length > 0) {
//             for (const node of mutation.addedNodes) {
//               if (node.nodeType === 1) { // Element node
//                 const fieldset = node.tagName === 'FIELDSET' ? node : node.closest?.('fieldset.product-form__input--pill');
//                 if (fieldset) {
//                   const legend = fieldset.querySelector('legend');
//                   if (legend && (legend.textContent.includes('Colour Code') || legend.textContent.includes('Color Code'))) {
//                     fieldset.classList.add('color-code-fieldset');
//                     // CSS handles hiding labels automatically
//                     newElementsAdded = true;
//                     shouldUpdate = true;
//                     break;
//                   }
//                 }
//               }
//             }
//           }
          
//           // Check if Colour Code labels were modified
//           if (target && target.tagName === 'LABEL') {
//             const fieldset = target.closest('fieldset.product-form__input--pill');
//             if (fieldset) {
//               const legend = fieldset.querySelector('legend');
//               if (legend && (legend.textContent.includes('Colour Code') || legend.textContent.includes('Color Code'))) {
//                 fieldset.classList.add('color-code-fieldset');
//                 // CSS handles hiding labels automatically
//                 // Check if this label has a stored color name but is showing a number
//                 if (target.dataset.colorName) {
//                   const textNode = Array.from(target.childNodes).find(n => n.nodeType === 3);
//                   const currentText = textNode?.textContent?.trim();
//               // If showing a number but we have a color name stored, show loading then re-apply
//               if (currentText && /^\d+$/.test(currentText)) {
//                 showLoading(target);
//                 // Re-apply after showing loading (longer delay for smoother transition)
//                 setTimeout(() => {
//                   textNode.textContent = target.dataset.colorName;
//                   setTimeout(() => {
//                     hideLoading(target);
//                   }, 100);
//                 }, 200);
//                 shouldUpdate = true;
//                 break;
//               }
//                 } else {
//                   // No stored name, try to find one
//                   const radio = fieldset.querySelector(`input[type="radio"][id="${target.getAttribute('for')}"]`);
//                   if (radio) {
//                     const textNode = Array.from(target.childNodes).find(n => n.nodeType === 3);
//                     const currentText = textNode?.textContent?.trim();
//                     if (currentText && /^\d+$/.test(currentText)) {
//                       const colorInfo = findColorName(radio.value);
//                       if (colorInfo) {
//                         showLoading(target);
//                         setTimeout(() => {
//                           textNode.textContent = colorInfo.colorName;
//                           target.dataset.colorName = colorInfo.colorName;
//                           target.dataset.colorFamily = colorInfo.familyName;
//                           target.dataset.familyCode = colorInfo.familyCode;
//                           setTimeout(() => {
//                             hideLoading(target);
//                           }, 100);
//                         }, 200);
//                         shouldUpdate = true;
//                         break;
//                       }
//                     }
//                   }
//                 }
//               }
//             }
//           }
          
//           // Also check if Colour Code fieldset content changed
//           if (target && target.closest) {
//             const fieldset = target.closest('fieldset.product-form__input--pill');
//             if (fieldset) {
//               const legend = fieldset.querySelector('legend');
//               if (legend && (legend.textContent.includes('Colour Code') || legend.textContent.includes('Color Code'))) {
//                 fieldset.classList.add('color-code-fieldset');
//                 // CSS handles hiding labels automatically
//                 const labels = fieldset.querySelectorAll('label');
//                 for (const label of labels) {
//                   if (label.dataset.colorName) {
//                     const textNode = Array.from(label.childNodes).find(n => n.nodeType === 3);
//                     const currentText = textNode?.textContent?.trim();
//                     if (currentText && /^\d+$/.test(currentText)) {
//                       // Show loading then re-apply
//                       showLoading(label);
//                       setTimeout(() => {
//                         textNode.textContent = label.dataset.colorName;
//                         setTimeout(() => {
//                           hideLoading(label);
//                         }, 100);
//                       }, 200);
//                       shouldUpdate = true;
//                       break; // Exit early once we find one that needs updating
//                     }
//                   } else {
//                     // No stored name, try to find one
//                     const radio = fieldset.querySelector(`input[type="radio"][id="${label.getAttribute('for')}"]`);
//                     if (radio) {
//                       const textNode = Array.from(label.childNodes).find(n => n.nodeType === 3);
//                       const currentText = textNode?.textContent?.trim();
//                       if (currentText && /^\d+$/.test(currentText)) {
//                         const colorInfo = findColorName(radio.value);
//                         if (colorInfo) {
//                           showLoading(label);
//                           setTimeout(() => {
//                             textNode.textContent = colorInfo.colorName;
//                             label.dataset.colorName = colorInfo.colorName;
//                             label.dataset.colorFamily = colorInfo.familyName;
//                             label.dataset.familyCode = colorInfo.familyCode;
//                             setTimeout(() => {
//                               hideLoading(label);
//                             }, 100);
//                           }, 200);
//                           shouldUpdate = true;
//                           break;
//                         }
//                       }
//                     }
//                   }
//                 }
//               }
//             }
//           }
//         }
        
//         // If new elements were added (variant change), update immediately without throttle
//         if (newElementsAdded && !isUpdating) {
//           console.log('[Color Code Replacer] New Colour Code elements detected, updating immediately...');
//           requestAnimationFrame(() => {
//             updateColorCodePills(true, true); // Force update with loading animation for variant changes
//             hideDisabledOptions(); // Hide disabled options
//           });
//         } else if (shouldUpdate && !isUpdating) {
//           const now = Date.now();
//           if (now - lastUpdateTime > UPDATE_THROTTLE) {
//             // Use requestAnimationFrame to ensure DOM is stable (no loading animation for reverts)
//             requestAnimationFrame(() => {
//               setTimeout(() => {
//                 updateColorCodePills(false, false); // No loading animation for small reverts
//               }, 50);
//             });
//           }
//         }
//       });
      
//       if (document.body) {
//         observer.observe(document.body, {
//           childList: true,
//           subtree: true,
//           characterData: true // Watch text changes to catch reverts
//         });
//       }
//     }
    
//     // Also set up a periodic check to re-apply color names (more frequent)
//     const intervalId = setInterval(() => {
//       if (isUpdating) return;
      
//       // Update Colour Family label periodically
//       updateColourFamilyLabel();
      
//       const fieldsets = document.querySelectorAll('fieldset.product-form__input--pill');
//       let colorCodeFieldset = null;
      
//       fieldsets.forEach(fieldset => {
//         const legend = fieldset.querySelector('legend');
//         if (legend) {
//           const legendText = legend.textContent.trim();
//           if (legendText === 'Colour Code' || legendText === 'Color Code') {
//             colorCodeFieldset = fieldset;
//             fieldset.classList.add('color-code-fieldset');
//             // CSS handles hiding labels automatically
//           }
//         }
//       });
      
//       if (colorCodeFieldset) {
//         const labels = colorCodeFieldset.querySelectorAll('label');
        
//         // Check if any labels were reverted to numbers (should show color names)
//         let needsUpdate = false;
//         for (const label of labels) {
//           const textNode = Array.from(label.childNodes).find(n => n.nodeType === 3);
//           const currentText = textNode?.textContent?.trim();
//           // If showing a number but we have a color name stored, show loading then re-apply
//           if (currentText && /^\d+$/.test(currentText) && label.dataset.colorName) {
//             showLoading(label);
//             setTimeout(() => {
//               textNode.textContent = label.dataset.colorName;
//               setTimeout(() => {
//                 hideLoading(label);
//               }, 100);
//             }, 200);
//             needsUpdate = true;
//           }
//           // If no color name stored, try to find one
//           if (!label.dataset.colorName && currentText && /^\d+$/.test(currentText)) {
//             const radio = colorCodeFieldset.querySelector(`input[type="radio"][id="${label.getAttribute('for')}"]`);
//             if (radio) {
//               const colorInfo = findColorName(radio.value);
//               if (colorInfo) {
//                 showLoading(label);
//                 setTimeout(() => {
//                   textNode.textContent = colorInfo.colorName;
//                   label.dataset.colorName = colorInfo.colorName;
//                   label.dataset.colorFamily = colorInfo.familyName;
//                   label.dataset.familyCode = colorInfo.familyCode;
//                   setTimeout(() => {
//                     hideLoading(label);
//                   }, 100);
//                 }, 200);
//                 needsUpdate = true;
//               }
//             }
//           }
//         }
        
//         if (needsUpdate) {
//           const now = Date.now();
//           if (now - lastUpdateTime > UPDATE_THROTTLE) {
//             updateColorCodePills(false, false); // No loading animation for periodic checks
//           }
//         }
//       }
//     }, 300); // Check every 300ms (more frequent)
    
//     // Store interval ID for potential cleanup (though it runs for page lifetime)
//     window._colorCodeIntervalId = intervalId;
    
//     // Continuous monitoring using requestAnimationFrame for instant revert prevention
//     let lastRAFCheck = 0;
//     const rafCheck = () => {
//       const now = Date.now();
//       // Check every 100ms (not every frame to reduce overhead)
//       if (now - lastRAFCheck > 100 && !isUpdating) {
//         lastRAFCheck = now;
        
//         const fieldsets = document.querySelectorAll('fieldset.product-form__input--pill');
//         let fixed = false;
        
//         fieldsets.forEach(colorCodeFieldset => {
//           const legend = colorCodeFieldset.querySelector('legend');
//           if (legend && (legend.textContent.includes('Colour Code') || legend.textContent.includes('Color Code'))) {
//             colorCodeFieldset.classList.add('color-code-fieldset');
//             // CSS handles hiding labels automatically
//             const labels = colorCodeFieldset.querySelectorAll('label');
            
//             for (const label of labels) {
//               const textNode = Array.from(label.childNodes).find(n => n.nodeType === 3);
//               const currentText = textNode?.textContent?.trim();
              
//               // If showing a number but we have a color name stored, show loading then fix
//               if (currentText && /^\d+$/.test(currentText) && label.dataset.colorName) {
//                 showLoading(label);
//                 setTimeout(() => {
//                   textNode.textContent = label.dataset.colorName;
//                   setTimeout(() => {
//                     hideLoading(label);
//                   }, 100);
//                 }, 200);
//                 fixed = true;
//               }
//               // If no color name stored but showing a number, try to find one
//               else if (!label.dataset.colorName && currentText && /^\d+$/.test(currentText)) {
//                 const radio = colorCodeFieldset.querySelector(`input[type="radio"][id="${label.getAttribute('for')}"]`);
//                 if (radio) {
//                   const colorInfo = findColorName(radio.value);
//                   if (colorInfo) {
//                     showLoading(label);
//                     setTimeout(() => {
//                       textNode.textContent = colorInfo.colorName;
//                       label.dataset.colorName = colorInfo.colorName;
//                       label.dataset.colorFamily = colorInfo.familyName;
//                       label.dataset.familyCode = colorInfo.familyCode;
//                       setTimeout(() => {
//                         hideLoading(label);
//                       }, 100);
//                     }, 200);
//                     fixed = true;
//                   }
//                 }
//               }
//             }
//           }
//         });
        
//         if (fixed) {
//           console.log('[Color Code Replacer] Fixed reverts via RAF check');
//         }
//       }
      
//       requestAnimationFrame(rafCheck);
//     };
    
//     // Start RAF monitoring
//     requestAnimationFrame(rafCheck);
//   }

//   // ULTRA-AGGRESSIVE: Hide labels immediately when script loads
//   // This happens before anything else - even before DOMContentLoaded
//   function hideAllLabelsImmediately() {
//     const fieldsets = document.querySelectorAll('fieldset.product-form__input--pill');
//     fieldsets.forEach(fieldset => {
//       const legend = fieldset.querySelector('legend');
//       if (legend) {
//         const legendText = legend.textContent.trim();
//         // Update Colour Family label
//         if (legendText === 'Colour Family' || legendText === 'Color Family') {
//           legend.textContent = 'Colour';
//         }
//         // ONLY target Colour Code fieldset - don't touch other variants
//         if (legendText === 'Colour Code' || legendText === 'Color Code') {
//           // Add class immediately so CSS can target it
//           fieldset.classList.add('color-code-fieldset');
//           // Hide ALL labels immediately (synchronously, no delay)
//           const labels = fieldset.querySelectorAll('label');
//           labels.forEach(label => {
//             // Check if label text is a number
//             const textNode = Array.from(label.childNodes).find(n => n.nodeType === 3);
//             const text = textNode?.textContent?.trim();
//             // Hide if it's a number OR if it doesn't have data-color-name
//             if ((text && /^\d+$/.test(text)) || !label.dataset.colorName) {
//               label.style.display = 'none';
//             }
//           });
//         }
//       }
//     });
//   }
  
//   // Hide labels immediately (runs right now, synchronously)
//   hideAllLabelsImmediately();
  
//   // Also hide labels in a loop for the first 2 seconds (every 10ms)
//   // This ensures we catch labels even if they're added dynamically
//   let hideAttempts = 0;
//   const hideInterval = setInterval(() => {
//     hideAttempts++;
//     if (hideAttempts > 200) { // 200 attempts = 2000ms (2 seconds)
//       clearInterval(hideInterval);
//       return;
//     }
//     hideAllLabelsImmediately();
//   }, 10); // Every 10ms
  
//   // Also use MutationObserver to hide labels as soon as they're added
//   if (typeof MutationObserver !== 'undefined') {
//     const immediateHideObserver = new MutationObserver(() => {
//       hideAllLabelsImmediately();
//     });
    
//     // Start observing immediately
//     if (document.body) {
//       immediateHideObserver.observe(document.body, {
//         childList: true,
//         subtree: true
//       });
//     } else {
//       // Wait for body
//       const bodyWaitObserver = new MutationObserver(() => {
//         if (document.body) {
//           immediateHideObserver.observe(document.body, {
//             childList: true,
//             subtree: true
//           });
//           bodyWaitObserver.disconnect();
//         }
//       });
//       bodyWaitObserver.observe(document.documentElement, {
//         childList: true
//       });
//     }
//   }
  
//   // Start immediately - don't wait for DOMContentLoaded
//   // This ensures we can hide numbers before they're visible
//   // CSS is already injected above, so just run init
//   if (document.readyState === 'loading') {
//     // Run init immediately to set up observers
//     init();
//     // And also listen for DOMContentLoaded as backup
//     document.addEventListener('DOMContentLoaded', () => {
//       console.log('[Color Code Replacer] DOMContentLoaded - running additional preload');
//       updateColourFamilyLabel();
//       hideAllLabelsImmediately();
//       updateColorCodePills(true, false);
//       hideDisabledOptions();
//     });
//   } else {
//     // DOM already loaded
//     init();
//     // Run immediate update
//     requestAnimationFrame(() => {
//       updateColourFamilyLabel();
//       hideAllLabelsImmediately();
//       updateColorCodePills(true, false);
//       hideDisabledOptions();
//     });
//   }

//   // Export for manual trigger
//   window.updateColorCodePills = updateColorCodePills;

//   // Helper function to find missing color codes
//   window.findMissingColorCodes = function() {
//     const fieldsets = document.querySelectorAll('fieldset.product-form__input--pill');
//     let colorCodeFieldset = null;
    
//     fieldsets.forEach(fieldset => {
//       const legend = fieldset.querySelector('legend');
//       if (legend && (legend.textContent.includes('Colour Code') || legend.textContent.includes('Color Code'))) {
//         colorCodeFieldset = fieldset;
//         fieldset.classList.add('color-code-fieldset');
//         // CSS handles hiding labels automatically
//       }
//     });
    
//     if (!colorCodeFieldset) {
//       console.log('No Colour Code fieldset found');
//       return;
//     }
    
//     const radioInputs = colorCodeFieldset.querySelectorAll('input[type="radio"]');
//     const missingCodes = [];
    
//     radioInputs.forEach(radio => {
//       const colorCode = radio.value;
//       const label = colorCodeFieldset.querySelector(`label[for="${radio.id}"]`);
//       if (label) {
//         const textNode = Array.from(label.childNodes).find(n => n.nodeType === 3);
//         const currentText = textNode?.textContent?.trim();
        
//         // Check if it's showing a number (meaning no mapping found)
//         if (currentText && /^\d+$/.test(currentText)) {
//           const colorInfo = findColorName(colorCode);
//           if (!colorInfo) {
//             missingCodes.push({
//               code: colorCode,
//               labelText: currentText,
//               radioId: radio.id
//             });
//           }
//         }
//       }
//     });
    
//     if (missingCodes.length > 0) {
//       console.log('⚠️ Missing Color Codes:', missingCodes);
//       console.log('Add these to your colorMap:');
//       missingCodes.forEach(item => {
//         console.log(`  Code: ${item.code}, Current text: "${item.labelText}"`);
//       });
//       return missingCodes;
//     } else {
//       console.log('✅ All color codes have mappings!');
//       return [];
//     }
//   };

// })();












/**
 * Variant Name Changer
 * Changes "Colour Family" or "Color Family" to "Colour" on the front end
 */

(function() {
  'use strict';

  /**
   * Change "Colour Family" to "Colour" on the front end
   */
  function updateColourFamilyLabel() {
    const fieldsets = document.querySelectorAll('fieldset.product-form__input--pill');
    fieldsets.forEach(fieldset => {
      const legend = fieldset.querySelector('legend');
      if (legend) {
        const legendText = legend.textContent.trim();
        if (legendText === 'Colour Family' || legendText === 'Color Family') {
          legend.textContent = 'Colour';
          console.log('[Variant Name Changer] Changed "Colour Family" to "Colour"');
        }
      }
    });
  }

  // Run when DOM is ready
  function init() {
    // Change "Colour Family" to "Colour" on the front end
    updateColourFamilyLabel();
    
    // Watch for DOM changes and update when new fieldsets are added
    if (typeof MutationObserver !== 'undefined') {
      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === 1) { // Element node
              const fieldset = node.tagName === 'FIELDSET' ? node : 
                (node.querySelector?.('fieldset.product-form__input--pill') || 
                 node.closest?.('fieldset.product-form__input--pill'));
              if (fieldset) {
                const legend = fieldset.querySelector('legend');
                if (legend) {
                  const legendText = legend.textContent.trim();
                  if (legendText === 'Colour Family' || legendText === 'Color Family') {
                    legend.textContent = 'Colour';
                    console.log('[Variant Name Changer] Changed "Colour Family" to "Colour"');
                  }
                }
              }
            }
          }
        }
      });
      
      // Start observing
      if (document.body) {
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      } else {
        // Wait for body
        const bodyObserver = new MutationObserver(() => {
          if (document.body) {
            observer.observe(document.body, {
              childList: true,
              subtree: true
            });
            bodyObserver.disconnect();
          }
        });
        bodyObserver.observe(document.documentElement, {
          childList: true
        });
      }
    }
    
    // Periodic check to ensure label stays updated
    setInterval(() => {
      updateColourFamilyLabel();
    }, 1000);
  }

  // Start immediately
  if (document.readyState === 'loading') {
    // Run init immediately to set up observers
    init();
    // And also listen for DOMContentLoaded as backup
    document.addEventListener('DOMContentLoaded', () => {
      console.log('[Variant Name Changer] DOMContentLoaded - running update');
      updateColourFamilyLabel();
    });
  } else {
    // DOM already loaded
    init();
    // Run immediate update
    requestAnimationFrame(() => {
      updateColourFamilyLabel();
    });
  }

})();
